document.addEventListener("DOMContentLoaded", function () {
  initFAQAccordion();
});

function initFAQAccordion() {
  const faqToggles = document.querySelectorAll("[data-faq-toggle]");

  if (faqToggles.length === 0) return;

  faqToggles.forEach((toggle) => {
    toggle.addEventListener("click", handleFAQToggle);
    toggle.addEventListener("keydown", handleFAQKeydown);
  });
}

function handleFAQToggle(event) {
  const button = event.currentTarget;
  const answer = button.nextElementSibling;
  const isExpanded = button.getAttribute("aria-expanded") === "true";

  // Close all other FAQ items
  closeAllFAQItems(button);

  // Toggle current item
  if (!isExpanded) {
    openFAQItem(button, answer);
  }
}

function handleFAQKeydown(event) {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    handleFAQToggle(event);
  }
}

function openFAQItem(button, answer) {
  button.setAttribute("aria-expanded", "true");
  answer.setAttribute("aria-hidden", "false");
}

function closeFAQItem(button, answer) {
  button.setAttribute("aria-expanded", "false");
  answer.setAttribute("aria-hidden", "true");
}

function closeAllFAQItems(currentButton) {
  const allToggles = document.querySelectorAll("[data-faq-toggle]");

  allToggles.forEach((toggle) => {
    if (toggle !== currentButton) {
      const answer = toggle.nextElementSibling;
      closeFAQItem(toggle, answer);
    }
  });
}
